/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import * as C from "../../../css/PersonalSellingRequest/request/requestComplete";
import * as R from "../../../css/PersonalSellingRequest/requestForm";
import CardButton from "../../../componant/buttons/cardButton";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../css/complete-buying-request/complete-buying-request.css";
import {
  BuyingInfo,
  PersonBuyingInfo,
} from "../RequestForm/PersonalRequestForm/PersonalRequestForm";
import { TradingBuyingInfo } from "../RequestForm/CoorporateRequestForm/Trading/TradingRequestForm";
import { RentalBuyingInfo } from "../RequestForm/CoorporateRequestForm/Rental/RentalRequestForm";
import { LicenseBuyingInfo } from "../RequestForm/LicenseRequestForm/LicenseReuestForm";
import { toast } from "wc-toast";
import { postNumbaSellCodeDescription } from "../../../api/sell";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber";
import { useAtom } from "jotai/index";
import { header_userInfo } from "../../../data/atom/mypage/mypage_atom";
import { scrollToTop } from "../../../utils/hooks/scrollToTop";
import useDeviceDetect from "../../../helpers/useMobile";

const GoodsInfo = ({ data }) => {
  const type = data?.type;
  switch (type) {
    case 2101:
      return <PersonBuyingInfo buyReqData={data} />;
    case 2102:
      return <TradingBuyingInfo buyReqData={data} />;
    case 2103:
      return <RentalBuyingInfo buyReqData={data} />;
    case 2104:
      return <LicenseBuyingInfo buyReqData={data} />;
  }
};

const fileDownLoad = (file) => {
  if (file) {
    const blob = new Blob([file]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = file.name; // 다운로드할 파일의 이름
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } else {
    toast.error("파일이 없습니다.");
  }
};

const BuyerInfo = ({ data }) => {
  const type = data?.type;

  return (
    <div className="FormDIv">
      <R.FormDetails_Heading>신청자 정보</R.FormDetails_Heading>
      <Table bordered responsive className="table-form">
        <tbody>
          <tr>
            <R.FormTable_Th width="20%">
              {/* {type === 2103 ? "임차인 이름" : "구매자 이름"} */}
              이름
            </R.FormTable_Th>
            <td className="paddingLeft">{data?.user_nm}</td>
          </tr>
          <tr>
            <R.FormTable_Th width="20%">
              {/* {type === 2103 ? "임차인 " : "구매자 "} */}
              휴대폰번호
            </R.FormTable_Th>
            <td className="paddingLeft">{formatPhoneNumber(data?.phone)}</td>
          </tr>
          <tr>
            <R.FormTable_Th width="20%">
              {/* {type === 2103 ? "임차인 " : "구매자 "} */}
              주소
            </R.FormTable_Th>
            <td className="paddingLeft" colSpan={3}>
              {data?.zip + " " + data?.addr1 + " " + (data?.addr2 ?? "")}
            </td>
          </tr>
          {type === 2103 && (
            <>
              <tr>
                <R.FormTable_Th width="20%">차량등록증</R.FormTable_Th>
                <td className="paddingLeft" colSpan={3}>
                  <div className="d-flex  align-items-center">
                    <label
                      className="fileBtn"
                      htmlFor="car_file"
                      onClick={() => {
                        fileDownLoad(data?.car_file);
                      }}
                    >
                      파일보기
                    </label>
                    <div className="txt_attach ms-2">
                      {data?.car_file?.name}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <R.FormTable_Th width="30%">
                  화물운송종사자격증명서
                </R.FormTable_Th>
                <td className="paddingLeft" colSpan={3}>
                  <div className="d-flex  align-items-center">
                    <label
                      className="fileBtn"
                      htmlFor="fw_file"
                      onClick={() => {
                        fileDownLoad(data?.fw_file);
                      }}
                    >
                      파일보기
                    </label>
                    <div className="txt_attach ms-2">{data?.fw_file?.name}</div>
                  </div>
                </td>
              </tr>
            </>
          )}
          <tr>
            <R.FormTable_Th width="20%">요청내용</R.FormTable_Th>
            <td className="paddingLeft" colSpan={3}>
              {data?.req_comment}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

const RequestComplete = ({ subActiveTab }) => {
  const isIOS = () => { return /(iPad|iPhone|iPod|Mac).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent) && !window.MSStream; };
  const isMobile = useDeviceDetect();
  const [data, setData] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useAtom(header_userInfo);
  const servicePhoneNum = "010-4478-8944";

  useEffect(() => {
    scrollToTop();
    setData(location.state);

    let cd_seq = 0;

    if (userInfo.user_type_cd === "201") {
      cd_seq = 2801;
    }

    // async function fetchData() {
    //   try {
    //     const response = await postNumbaSellCodeDescription({
    //       code: location.state?.type,
    //     });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // }
    // fetchData();

    // try {
    //   const response = await postNumbaSellCodeDescription({
    //     code: location.state?.type,
    //   });
    // } catch (err) {
    //   console.log(err);
    // }
  }, []);

  const goToPhonCallApp = () => {
    const digitsOnly = servicePhoneNum.replace(/-/g, "");
    if (!isMobile) {
      alert("전화는 모바일에서만 가능합니다.");
      return;
    }
    if ((typeof TOPTOP_APP) === 'object' && (typeof TOPTOP_APP.makePhoneCall) === 'function') {
      TOPTOP_APP.makePhoneCall(digitsOnly);
    } else if (isIOS()){
      webkit.messageHandlers.makePhoneCall.postMessage(digitsOnly);
    } else {
      window.location.href = `tel:${digitsOnly}`;
    }
  };

  if (subActiveTab === "first") {
    return (
      <>
        <div className="request__complete__wrapper">
          <Container>
            <Row>
              <Col md={12}>
                <div>
                  <C.FormHeading_div>
                    <C.Form_Heading>거래신청 완료</C.Form_Heading>
                  </C.FormHeading_div>
                </div>
                <GoodsInfo data={data} />
                <BuyerInfo data={data} />

                <div className="d-flex flex-column align-items-center pb-30px" style={{marginBottom:'30px'}}>
                  {/* <div className="d-flex flex-column align-items-center  selling-success">
                    <div>거래신청이 완료되었습니다.</div>
                    <div>담당 매니저가 빠른 시간에 연락드리겠습니다.</div>
                  </div>
                  <div className="mt-3">
                    문의가 필요하실때는 <span>고객센터: </span> 로
                    연락주세요.
                  </div> */}
                </div>

                <div className="FormDIv">
                 <R.FormDetails_Heading>꼭 확인하세요!</R.FormDetails_Heading>
                 
                 <div className="mb-3 mt-3">거래신청이 완료되었습니다. 담당 매니저가 빠른 시간 내에 연락드리겠습니다. <br/>               
                    추가로 궁금하신 사항은 연락주시면 친절히 상담드리겠습니다. <br/>
                    상담시 매물 번호, 신청자 성명, 판매신청의 경우 자동차등록증을 확보해두시면 더욱 빠르고 정확한 상담이 가능합니다.
                  </div>

                 {/* <Table bordered>
                   <tbody>
                     <tr>
                       <R.FormTable_Th width="20%">입금계좌</R.FormTable_Th>
                       <td className="paddingLeft">
                        기업은행 137-119035-04-033 / 예금주(어셈브릭스 에스크로)
                       </td>
                     </tr>
                     <tr>
                       <R.FormTable_Th width="20%">
                         제출서류 <br /> (등기제출)
                       </R.FormTable_Th>
                       <td className="paddingLeft">
                         위임장 3부, 인감증명서 2부, 운전면허증 사본 1부, 화물운송자격증, 차량등록증, 사진2매
                       </td>
                     </tr>
                     <tr>
                       <R.FormTable_Th width="20%">
                         제출 주소
                       </R.FormTable_Th>
                       <td className="paddingLeft">
                         경기도 광명시 양지로 21, T타워 1017호. 주식회사 온플랫(어셈브릭스 영업법인)
                       </td>
                     </tr>
                     <tr>
                       <R.FormTable_Th width="20%">고객센터</R.FormTable_Th>
                       <td className="paddingLeft">
                         010-4478-8944
                       </td>
                     </tr>
                   </tbody>
                 </Table> */}
                </div>
                <div className="phone-box d-nonex">  
                  <div className="phone-box1">             
                    <div
                      className="phone-box2"
                      style={{                        
                        cursor: isMobile ? "pointer" : "default"
                      }}
                      onClick={() => {
                        if (isMobile) {
                          goToPhonCallApp();
                        }
                      }}
                    >
                      <span className="phone-text">고객센터</span>
                      <span className="phone">{servicePhoneNum}</span>
                    </div>
                    <span className="center-time">평일 09:00~18:00</span>
                  </div>     
                  {isMobile && (
                    <img
                      src={"/img/icon_phone.svg"}
                      alt=""
                      style={{ width: "80px", height: "80px", cursor: isMobile ? "pointer" : "default" }}
                      onClick={() => {
                        if (isMobile) {
                          goToPhonCallApp();
                        }
                      }}
                    />
                  )}
                </div>                
                {/* <R.Para_Content>
                 ※ 임대금을 회사법인 계좌로 입금하시고 임대에 필요한 서류를 탑탑에 등기로 제출하시면 매매가 진행됩니다.
                </R.Para_Content> */}

                <div className="d-flex justify-content-center mt-4">
                  <CardButton
                    width="390px"
                    bg="#FF9C00"
                    name="확인"
                    minWidth="300px"
                    onClick={() => {
                      navigate("/selling", {
                        replace: true,
                      });
                    }}
                  ></CardButton>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  } else if (subActiveTab === "second") {
    return <>wekfgwejhfgjwefjwejhfgewgh</>;
  }
  return null;
};

export default RequestComplete;
